/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createFieldHook } from '../../core/factories/createFieldHook.js';
import { createListHook } from '../../core/factories/createListHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetAdminCompetitionsRow } from '../openapi-types.gen.js';
import type { PagedData } from '../../types/PagedData.js';
import { type useGetAdminCompetitionsArgs, useGetAdminCompetitionsSpec, useGetAdminCompetitionsRealtime, useGetAdminCompetitionsPagination } from '../specs/admin.spec.gen.js';
import type { PaginationContract } from '../../core/factories/createListHook.js';

export type { GetAdminCompetitionsRow } from '../openapi-types.gen.js';
export type { useGetAdminCompetitionsArgs } from '../specs/admin.spec.gen.js';

// Codegen-typed pagination contract is narrower than the runtime
// PaginationContract signature (which takes unknown args). The cast erases
// the call-site narrowness — the runtime fetcher itself remains typed.
const _useGetAdminCompetitionsPaginationContract = useGetAdminCompetitionsPagination as unknown as PaginationContract;

/**
 * Manual pagination: returns `fetchNextPage` / `hasNextPage` /
 * `isFetchingNextPage` so the caller wires a "Load more" button or
 * pagination control. Same cache entry as `useGetAdminCompetitionsInfinite` — both
 * read/write the same `PagedData<GetAdminCompetitionsRow>` blob.
 *
 * @remarks Available query params (forwarded automatically; pass
 * via the hook's args): limit, cursor.
 */
const _useGetAdminCompetitions = createListHook({
  spec: useGetAdminCompetitionsSpec,
  realtime: useGetAdminCompetitionsRealtime,
  entityKey: null,
  pagination: _useGetAdminCompetitionsPaginationContract,
});
export const useGetAdminCompetitions = _useGetAdminCompetitions as (args: useGetAdminCompetitionsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetAdminCompetitions>;


/**
 * Auto-infinite: same cache as `useGetAdminCompetitions`, but the last-row viewport
 * sentinel auto-fires `fetchNextPage` so the consumer never has to wire
 * it. Use for scroll-driven feeds; use `useGetAdminCompetitions` for "Load more"
 * buttons / non-scroll UX.
 */
const _useGetAdminCompetitionsInfinite = createListHook({
  spec: useGetAdminCompetitionsSpec,
  realtime: useGetAdminCompetitionsRealtime,
  entityKey: null,
  pagination: _useGetAdminCompetitionsPaginationContract,
  autoLoadMore: true,
});
export const useGetAdminCompetitionsInfinite = _useGetAdminCompetitionsInfinite as (args: useGetAdminCompetitionsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetAdminCompetitionsInfinite>;


/**
 * Per-field subscription hook for the `useGetAdminCompetitions` cache entry. Call inside
 * an `<Items>` render tree (typically from a leaf component). Returns the
 * named field's value for the given row id; only the call site re-renders
 * when that field changes. Uses TanStack's canonical "per-component select"
 * pattern internally.
 *
 *     function Volume({ pubkey }) {
 *       const value = useGetAdminCompetitionsField(pubkey, 'volume24h');
 *       return <span>{value}</span>;
 *     }
 */
export const useGetAdminCompetitionsField = createFieldHook<GetAdminCompetitionsRow>('useGetAdminCompetitionsField');

/**
 * Hover/intent prefetch companion for `useGetAdminCompetitions` (also covers
 * `useGetAdminCompetitionsInfinite` — same cache entry). Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * for page 1 and writes the response into the cache. The component owning
 * the callback does NOT subscribe — no re-renders on data, no NATS
 * subscription. Idempotent: TanStack `prefetchQuery` is a no-op when a
 * fresh cache entry already exists.
 *
 *     function NavLink() {
 *       const prefetch = usePrefetchGetAdminCompetitions();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({})}
 *           onFocus={() => prefetch({})}
 *         >Markets</a>
 *       );
 *     }
 */
export const usePrefetchGetAdminCompetitions = createPrefetchHook(useGetAdminCompetitionsSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetAdminCompetitionsArgs>;
